module.exports = __webpack_public_path__ + "static/smith3-301365c5d699cb15d0054e5c5ca7487d.jpg";